import { render, staticRenderFns } from "./ExpenseMetricConfigurationPage.vue?vue&type=template&id=4507c620"
import script from "./ExpenseMetricConfigurationPage.vue?vue&type=script&lang=ts"
export * from "./ExpenseMetricConfigurationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports